const DEFUALT_STATE = {
  useEcommerceDisabled: null,
  contactUsPageUrl: "",
  contactUsPageDepartmentId: "",
  faqPageUrl: "", 
};

export const site = (state = DEFUALT_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    default:
      return state;
  }
};
